import { FC } from 'react';
import * as S from './style';

const HuboInfomation: FC = () => {
  return (
    <S.TextContainer>
      <h1>후보들 프로필 확인하기</h1>
    </S.TextContainer>
  );
};

export default HuboInfomation;
